module.exports = __webpack_public_path__ + "eba62d4e0050e110b00bf2054f233728.png";